module.exports = __webpack_public_path__ + "static/media/2.697ec468.png";